package com.solevo.dist.network.implementation.firebase.utils.time

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.datetime.Instant

fun Timestamp.toKotlinInstant(): Instant {
    return Instant.fromEpochSeconds(this.seconds, this.nanoseconds.toLong())
}




